import React from "react";
import ShareIcon from "src/assets/images/website-images/shareicon.png";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  shareTitle? : string;
  shareText? : string;
  index?: number;
}

const ShareComponent: React.FC<IProps> = ({ onClick, shareText , shareTitle , index, ...res }) => {
  const handleShare = async () => {
    const shareUrl = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle || "",
          text: `${shareText || ""}`,
          url: shareUrl,
        });
        console.log("Successfully shared");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert(
        "Share not supported on this device. Please copy the link manually: " +
          shareUrl
      );
    }
  };
  return (
    <div
      className="w-[25px] h-[25px] lg:w-[27px] lg:h-[27px] 2xl:w-[35px] 2xl:h-[35px] cursor-pointer bg-[#E4E4E4] rounded-full flex items-center justify-center"
      onClick={(e) => {
        handleShare();
        onClick && onClick(e);
      }}
      {...res}
      id={index || index === 0 ? `share-component-${index + 1}` : "share-icon"}
    >
      <img src={ShareIcon} alt="shareImg" />
    </div>
  );
};

export default ShareComponent;
